/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bulk_UploadInputs */

const en_bulk_upload = /** @type {(inputs: Bulk_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bulk Upload`)
};

const es_bulk_upload = /** @type {(inputs: Bulk_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga masiva`)
};

const fr_bulk_upload = /** @type {(inputs: Bulk_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload en masse`)
};

const de_bulk_upload = /** @type {(inputs: Bulk_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massen-Upload`)
};

const ja_bulk_upload = /** @type {(inputs: Bulk_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一括アップロード`)
};

const zh_bulk_upload = /** @type {(inputs: Bulk_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批量上传`)
};

const ar_bulk_upload = /** @type {(inputs: Bulk_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحميل جماعي`)
};

const id_bulk_upload = /** @type {(inputs: Bulk_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggah Massal`)
};

const it_bulk_upload = /** @type {(inputs: Bulk_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento multiplo`)
};

const ru_bulk_upload = /** @type {(inputs: Bulk_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Массовая загрузка`)
};

const pt_bulk_upload = /** @type {(inputs: Bulk_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload em massa`)
};

const ko_bulk_upload = /** @type {(inputs: Bulk_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일괄 업로드`)
};

/**
* | output |
* | --- |
* | "Bulk Upload" |
*
* @param {Bulk_UploadInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const bulk_upload = /** @type {((inputs?: Bulk_UploadInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bulk_UploadInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bulk_upload(inputs)
	if (locale === "es") return es_bulk_upload(inputs)
	if (locale === "fr") return fr_bulk_upload(inputs)
	if (locale === "de") return de_bulk_upload(inputs)
	if (locale === "ja") return ja_bulk_upload(inputs)
	if (locale === "zh") return zh_bulk_upload(inputs)
	if (locale === "ar") return ar_bulk_upload(inputs)
	if (locale === "id") return id_bulk_upload(inputs)
	if (locale === "it") return it_bulk_upload(inputs)
	if (locale === "ru") return ru_bulk_upload(inputs)
	if (locale === "pt") return pt_bulk_upload(inputs)
	return ko_bulk_upload(inputs)
});